import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { commitMutation, graphql } from 'react-relay';
import { Analytics, GlobalNotifications, Intent } from '../../Modules';
import LineItems from '../Sections/LineItems/LineItems';
import nullifyEmptyStrings from '../../../lib/utils/nullifyEmptyStrings';
import { arrayMove } from '../../../lib/utils/array';

export default class InvoiceLineItems extends React.Component {

  static propTypes = {
    canEdit: PropTypes.bool.isRequired,
    totalPaid: PropTypes.number.isRequired,
    node: PropTypes.object.isRequired,
    relay: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      localLineItems: _.cloneDeep(this.props.node.invoice_line_items.edges)
    };
    this.deleteLineItem = this.deleteLineItem.bind(this);
    this.resetEditLineItem = this.resetEditLineItem.bind(this);
    this.lineItemChangeHandler = this.lineItemChangeHandler.bind(this);
    this.updateLineItem = this.updateLineItem.bind(this);
    this.moveLineItem = this.moveLineItem.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    // Update localLineItems if any edges are added/deleted/updated
    this.setState({
      localLineItems: _.cloneDeep(nextProps.node.invoice_line_items.edges)
    });
  }

  lineItemChangeHandler(lineItem, idx) {
    const obj = _.cloneDeep(this.state);
    obj.localLineItems[idx].node = lineItem;
    this.setState({ ...obj });
  }

  resetEditLineItem(idx) {
    const obj = _.cloneDeep(this.state);
    obj.localLineItems[idx] = _.cloneDeep(
      this.props.node.invoice_line_items.edges[idx]
    );
    this.setState(obj);
  }

  moveLineItem(source, destination) {
    const localLineItems = arrayMove(this.state.localLineItems, source, destination);
    localLineItems[destination].node.position = destination + 1;
    this.setState({
      localLineItems
    }, () => this.updateLineItem(destination));
  }

  updateLineItem(idx, successCb, failureCb) {
    const onError = () => {
      if (failureCb) failureCb();
      GlobalNotifications.show({
        message: 'Unable to update line item',
        intent: Intent.DANGER
      });
    };
    const onCompleted = () => {
      if (successCb) successCb();
      Analytics.trackEvent('updated-line-item');
    };
    const lineItem = _.pick(
      nullifyEmptyStrings(this.state.localLineItems[idx].node),
      [
        'id',
        'description',
        'position',
        'price_cents',
        'price_currency',
        'quantity',
        'title'
      ]
    );

    lineItem.quantity = parseInt(lineItem.quantity, 10);

    const mutation = graphql`
      mutation LineItems_updateInvoiceLineItemMutation(
        $input: UpdateInvoiceLineItemInput!
      ) {
        updateInvoiceLineItem(input: $input) {
          invoice {
            ...InvoiceContainer_node
          }
        }
      }
    `;

    const invoice = _.cloneDeep(this.props.node);
    invoice.invoice_line_items.edges = this.state.localLineItems;
    const optimisticResponse = {
      updateInvoiceLineItem: { invoice }
    };
    const environment = this.props.relay.environment;

    commitMutation(environment, {
      mutation,
      variables: {
        input: {
          ...lineItem
        }
      },
      optimisticResponse,
      onCompleted,
      onError
    });
  }

  deleteLineItem(idx, successCb, failureCb) {
    /* eslint-disable no-unused-vars */
    const onError = () => {
      if (failureCb) failureCb();
      GlobalNotifications.show({
        message: 'Unable to delete line item',
        intent: Intent.DANGER
      });
    };

    const onCompleted = () => {
      if (successCb) successCb();
      GlobalNotifications.show({
        message: 'Successfully deleted line item',
        intent: Intent.SUCCESS
      });
      Analytics.trackEvent('deleted-line-item');
    };

    const mutation = graphql`
      mutation LineItems_deleteInvoiceLineItemMutation(
        $input: DeleteInvoiceLineItemInput!
      ) {
        deleteInvoiceLineItem(input: $input) {
          deletedInvoiceLineItemId
          invoice {
            ...InvoiceContainer_node
          }
        }
      }
    `;

    const environment = this.props.relay.environment;
    const parentID = this.props.node.id;

    const configs = [
      {
        type: 'RANGE_DELETE',
        parentID,
        pathToConnection: ['invoice', 'invoice_line_items'],
        deletedIDFieldName: 'deletedInvoiceLineItemId',
        connectionKeys: [
          {
            key: 'InvoiceContainer_invoice_line_items',
            rangeBehavior: 'append'
          }
        ]
      }
    ];

    commitMutation(environment, {
      mutation,
      variables: {
        input: {
          id: this.props.node.invoice_line_items.edges[idx].node.id
        }
      },
      configs,
      onCompleted,
      onError
    });
  }

  render() {
    return (
      <LineItems
        lineItems={this.props.node.invoice_line_items.edges}
        localLineItems={this.state.localLineItems}
        updateLineItem={this.updateLineItem}
        deleteLineItem={this.deleteLineItem}
        moveLineItem={this.moveLineItem}
        resetEditLineItem={this.resetEditLineItem}
        lineItemChangeHandler={this.lineItemChangeHandler}
        readOnly={!this.props.canEdit}
        totalPaid={this.props.totalPaid}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/Document/Invoice/LineItems.js